const getPercentValue = (percentage, total) => {
    return percentage * total / 100;
}

export default getPercentValue;